/**
 * Form field length limits, applied as input `maxLength`. The values equal the store's limits in
 * `web-store-ui/application/src/components/constants.ts`, where the company limit is named
 * `maxCompanyName`.
 */

/** Address-line limit; no input in this repo uses it. */
export const maxAddressLineLength = 40;
/** City limit; no input in this repo uses it. */
export const maxCityLength = 40;
/**
 * `maxLength` of the first-name inputs in registration (`components/Register/RegisterForm.tsx`),
 * the contact form (`components/ContactFormWithFileAttacher/index.tsx`) and the free Stock List
 * download lead form (`components/StockList/Body.tsx`). The Stock List purchase form
 * (`components/StockList/Purchase.tsx`) doesn't use these limits.
 */
export const maxFirstNameLength = 20;
/** `maxLength` of the last-name inputs, in the same three forms as `maxFirstNameLength`. */
export const maxLastNameLength = 20;
/** Company-name limit; no input in this repo uses it. */
export const maxCompanyLength = 40;